export const getSemaforoColor = (horasTranscurridas, reglas) => {
  if (horasTranscurridas === null || horasTranscurridas === undefined) {
    return "semaforo__blanco";
  }

  if (!reglas) return "semaforo__blanco";

  const horas = horasTranscurridas;

  // Verde: 0 <= horas < max
  if (horas >= reglas.verde.min && horas < reglas.verde.max) {
    return "semaforo__verde";
  }

  // Amarillo: min <= horas < max
  if (horas >= reglas.amarillo.min && horas < reglas.amarillo.max) {
    return "semaforo__amarillo";
  }

  // Rojo: horas >= min
  if (horas >= reglas.rojo.min) {
    return "semaforo__rojo";
  }

  return "semaforo__blanco";
};
